<template>
  <div class="background">
    <div v-for="(style, i) in styles" :key="i" class="wrapper"
      :class="{ 'rotate-neg': style.rotateDirection === 'negative' }"
      :style="{ left: style.left, animationDelay: style.animationDelay, animationDuration:
                style.animationDuration, '--scale': style.scale, zIndex: style.zIndex }">
      <img :src="imageSrc" class="flower" :style="{ filter: `brightness(${style.brightness})` }"/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imageSrc: { type: String, required: true },
    count: { type: Number, default: 30 },
  },
  data() {
    return {
      styles: [],
    };
  },
  created() {
    const half = Math.floor(this.count / 2);
    const positionMin = 0;
    const positionMax = 20;
    const slowest = 30;
    const fastest = 20;

    for (let i = 0; i < half; i++) {
      const baseX = positionMin + Math.random() * (positionMax - positionMin);
      const delay = -(i * 75) / half;
      const t = (baseX - positionMin) / (positionMax - positionMin);

      const scale = 1 - t * 0.5;
      const brightness = 1 - t * 0.7;
      const zdepth = Math.floor(100-t*10)
      const duration = fastest + t * (slowest - fastest);

      this.styles.push({
        left: `${baseX}%`,
        animationDelay: `${delay}s`,
        animationDuration: `${duration}s`,
        zIndex:zdepth,
        scale,
        brightness,
        rotateDirection: 'positive',
      });
      this.styles.push({
        left: `${100 - baseX}%`,
        animationDelay: `${delay}s`,
        animationDuration: `${duration}s`,
        zIndex:zdepth,
        scale,
        brightness,
        rotateDirection: 'negative',
      });
    }
  },
};
</script>

<style scoped>
.background {
  position: fixed;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: -100;
  background: linear-gradient( to right, var(--blue) -30%, transparent 20%, transparent 80%, var(--blue) 130%);
}
.wrapper {
  position: absolute;
  top: -25%;
  width: 0;
  height: 0;
  pointer-events: none;
  animation-name: fall;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
.wrapper.rotate-neg .flower {
  animation: spin-neg 30s linear infinite;
}
.wrapper:not(.rotate-neg) .flower {
  animation: spin-pos 30s linear infinite;
}
.flower {
  position: absolute;
  width: 10em;
  height: 10em;
  user-select: none;
  pointer-events: none;
  transform-origin: center center;
}
@keyframes fall {
  0% { transform: translateY(-25vh); }
  100% { transform: translateY(125vh); }
}
@keyframes spin-pos {
  0% { transform: translateX(-50%) scale(var(--scale)) rotate(10deg); }
  100% { transform: translateX(-50%) scale(var(--scale)) rotate(370deg); }
}
@keyframes spin-neg {
  0% { transform: translateX(-50%) scale(var(--scale)) rotate(0deg); }
  100% { transform: translateX(-50%) scale(var(--scale)) rotate(-360deg); }
}
@media (max-width: 500px) {
  .background {
    opacity:0.5;
  }
}
</style>
